import { Typography } from "@material-ui/core";
import React from "react";

export const baseRateDataRenderer = (value) => (
    <Typography>{value?.name || "Нет данных"}</Typography>
);
